import React, { useContext, useEffect, useRef, useState } from 'react'
import { ButtonHeading, VendorDetailsTab } from 'components';
import { constant } from 'constants/constant';
import Tab from 'components/common/Tab';
import LoadingBar from 'react-top-loading-bar';
import Ledger from '../Ledger';
import useDocumentTitle from 'hooks/useDocumentTitle';
import { useLocation, useNavigate, useParams } from 'react-router-dom';
import { AdjustBalanceModal } from 'modals';
import { getSingleVenderData } from '_services/accountsServices/vendorsServices';
import { UserContext } from 'context';

const VendorsDetails = () => {
    useDocumentTitle("Vendor Details | T360");
    const location = useLocation();
    const navigate = useNavigate();
    const { masterData, setMasterDetailsList } = useContext(UserContext)
    const loadingBarRef = useRef(null);
    const queryParams = new URLSearchParams(location.search);
    const tabFromQuery = parseInt(queryParams.get('tab')) || 1;
    const [activeTab, setActiveTab] = useState(tabFromQuery);

    const [dataDetails, setDataDetail] = useState(null)
    const [openLedgerModal, setOpenLedgerModal] = useState(false);
    const [refreshLedger, setRefreshLedger] = useState(false);
    const [ledgerDetails, setLedgerDetails] = useState({});

    const handleActiveTabs = (e) => {
        setActiveTab(e);

        const params = new URLSearchParams(location.search);
        params.set('tab', e);
        navigate(`${location.pathname}?${params.toString()}`);
    }

    const tabProps = {
        tabList: constant.vendersDetailsTabs,
        callBackTab: (e) => handleActiveTabs(e),
        activeTab: activeTab
    }

    const onDataFetch = (data) => {
        setDataDetail(data)
    }

    let { id } = useParams();

    const [detailsData, setDetailsData] = useState({})
    const [loading, setLoading] = useState(false);

    const getDataVendorDetails = async (id_1) => {
        try {
            if (loadingBarRef.current) {
                loadingBarRef.current.continuousStart(); // Start the loading bar
            }
            let object = {
                vendor_id: id_1,
            }
            const res = await getSingleVenderData(object);
            if (res?.responseCode == 200) {
                setDetailsData(res?.data?.vendor)
                onDataFetch(res?.data?.vendor)
                setLoading(false);
            } else {
                setLoading(false);
            }
        } catch (error) {
            setLoading(false);
            // throw error;
        } finally {
            if (loadingBarRef.current) {
                loadingBarRef.current.complete(); // Complete the loading bar
            }
        }
    }

    useEffect(() => {
        if (id) {
            setLoading(true);
            getDataVendorDetails(id);
        }
    }, [id])

    const calback = () => {

        setOpenLedgerModal(false)
        setRefreshLedger(prev => !prev);
    }

    let LedgerAdjustModalProps = {
        isOpen: openLedgerModal,
        closeModal: (e) => setOpenLedgerModal(false),
        modalMainClass: "_dashCommon_Modal _prtThemeModal _smModal",
        footerPart: false,
        approvalBtn: true,
        approvalBtnTxt: 'Send for Approval',
        modalTitle: "Adjust Balance",
        submitTitle: "Adjust Balance",
        detailsData: ledgerDetails,
        venderType: "Vendor",
        calback: calback
    }

    return (
        <div>
            <LoadingBar
                color="#ffa800"
                ref={loadingBarRef}
                height={4}
                shadow={true}
                loaderSpeed={1000}
            />
            <ButtonHeading
                title={dataDetails?.name}
                buttonTitle="Back"
                isBackButton={true}
                onClickBackButton={() => { navigate('/account/vendors'); setMasterDetailsList({}) }} // navigate(-1)
                ledgerButtonTitle={activeTab == 2 ? "Adjust Balance" : ""}
                ledgerOnClick={() => setOpenLedgerModal(true)}
            />

            <div className='addPr_flBx commonDetails_bxs'>
                <Tab {...tabProps} />
                {activeTab === 1 && (
                    <VendorDetailsTab loadingBarRef={loadingBarRef} detailsData={detailsData} loading={loading} />
                )}
                {activeTab === 2 && <Ledger type={4} refresh={refreshLedger} setLedgerDetails={setLedgerDetails} />}
            </div>
            {openLedgerModal && <AdjustBalanceModal {...LedgerAdjustModalProps} />}

        </div>
    )
}

export default VendorsDetails;